import useGetUserById from 'features/user/hooks/useGetUserById';
import PropTypes from 'prop-types';

export default function DisplayUserEmailById({ userId }) {
  const { data: queriedUser } = useGetUserById(userId);

  return queriedUser?.email || null;
}
DisplayUserEmailById.propTypes = {
  userId: PropTypes.string.isRequired,
};
